export default __webpack_public_path__ + "static/media/Production.023615db.svg";